import api from '../utils/functions/api';

const baseURL = process.env.REACT_APP_API_URL;

async function postQrCodeApi(id) {
  try {
    const resp = await api.post(`${baseURL}/notify/gen-qr-payment`, {
      data: [
        {
          _id: id,
        },
      ],
    });

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function postGenLinkApi(id) {
  try {
    const resp = await api.post(`${baseURL}/notify/gen-link-payment`, {
      data: [
        {
          _id: id,
        },
      ],
    });

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function postSendMailApi(rowSelectedList) {
  try {
    const resp = await api.post(`${baseURL}/notify/send-mail`, {
      data: rowSelectedList
    });

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

const NotifyListApi = {
    postQrCodeApi,
    postGenLinkApi,
    postSendMailApi,
};
export default NotifyListApi;
